import {CollectorAdministratorCreateDto} from '../../../../PRMGApiClient';

export const registerExampleData: CollectorAdministratorCreateDto = {
  phoneNumberPrefix: '+48',
  phoneNumber: '111111111',
  firstName: 'Jan',
  surname: 'Kowalski',
  address: {
    addressId: 0,
    apartmentNumber: '2',
    postalCode: '01-001',
    street: 'Młynarska',
    city: 'Warszawa',
    buildingNumber: '1',
  },
};
